import { Box, Container, HStack, VStack, Divider, Link, Text, Image } from "@chakra-ui/react";
import { FaLinkedin, FaInstagram, FaYoutube, FaTwitter, FaEnvelope, FaFacebook } from "react-icons/fa";
import eduviclogo from "../resources/Eduvictechlogo.png";
import { ChevronDownIcon, ExternalLinkIcon } from "@chakra-ui/icons";

const FooterTech = () => {
  return (


  <Box  bg="gray.900" color="white" py={8}>
  <Container maxW="1200px" px={4}>
    <HStack spacing={6} align="start" justify="space-between">
      {/* Logo Section */}
      <VStack align="start" spacing={3} flexBasis="30%">
        <Link href="/">
        <Image src={eduviclogo} alt="Eduvic Logo" maxH="120px" objectFit="contain" />
        </Link>
      </VStack>
      
      <Divider orientation="vertical" height="200px" borderColor="gray.500" />

      {/* Important Links Section */}
      <VStack align="start" spacing={3} flexBasis="30%">
        <Text fontWeight="bold">Important Links</Text>
        <Link href="/technologies/landing-page#ourvision">Our Vision</Link>
        <Link href="/technologies/landing-page#ourproducts">Our Products</Link>
        <Link href="/technologies/about-tech">About Us</Link>
        <Link href={'/practice/'} isExternal  >
            Eduvic Practice Platform <ExternalLinkIcon mx="2px" />
        </Link>
        <Link href={'/platform/'} isExternal  >
            Eduvic Learning Platform <ExternalLinkIcon mx="2px" />
        </Link>
        {/* <Link href="/enrol">Enrol</Link>  */}
      </VStack>

      <Divider orientation="vertical" height="200px" borderColor="gray.500" />

          {/* Social Media Section */}
          <VStack align="start" spacing={3} flexBasis="30%">
            <Text fontWeight="bold">Connect with Eduvic</Text>
           
           <HStack spacing={2}>
            <Link href="mailto:tech@eduvic.com.au" isExternal>
              <FaEnvelope size="24px" />
            </Link>
            <Link href="mailto:tech@eduvic.com.au" isExternal>
              Email
            </Link>
          </HStack>

           <HStack spacing={2}>
                <Link href="https://www.linkedin.com/company/eduvic-technologies/" isExternal>
                  <FaLinkedin size="24px" />
                </Link>
                <Link href="https://www.linkedin.com/company/eduvic-technologies/" isExternal>
                 LinkedIn
                </Link>
                
              </HStack>

            <HStack spacing={2}>
                <Link href="https://www.facebook.com/profile.php?id=61571594075413" isExternal>
                  <FaFacebook size="24px" />
                </Link>
                <Link href="https://www.facebook.com/profile.php?id=61571594075413" isExternal>
                 Facebook
                </Link>
                
              </HStack>
              
              <HStack spacing={2}>
                <Link href="https://www.instagram.com/eduviccomau/F" isExternal>
                  <FaInstagram size="24px" />
                </Link>
                <Link href="https://www.instagram.com/eduviccomau/" isExternal>
                Instagram
                </Link>
               
              </HStack>
              
{/*               <HStack spacing={2}>
                <Link href="https://www.youtube.com/channel/UCATzCvYATjtZoK30_lX_rPA" isExternal>
                  <FaYoutube size="24px" />
                </Link>
                <Link href="https://www.youtube.com/channel/UCATzCvYATjtZoK30_lX_rPA" isExternal>
                YouTube
                </Link>
             
              </HStack>
              
              <HStack spacing={2}>
                <Link href="https://x.com/eduviccomau" isExternal>
                  <FaTwitter size="24px" />
                </Link>
                <Link href="https://x.com/eduviccomau" isExternal>
                  X
                </Link>
              </HStack> */}
            
          </VStack>
    </HStack>

    {/* Terms and Conditions and Copyright */}
    <Divider my={6} borderColor="gray.500" />
    <VStack spacing={3} align="center">
      <Link href="/technologies/termsandconditions" color="gray.400">
        Terms and Conditions
      </Link>
      <Text fontSize="sm" color="gray.500">
        © 2025 Eduvic Technologies
      </Text>
    </VStack>
  </Container>
</Box>

  );
};

export default FooterTech;
